<nav>
    <div class="nav nav-tabs" id="nav-tab" role="tablist">
      <a
        class="nav-item nav-link active"
        id="nav-home-tab"
        data-toggle="tab"
        href="#chat"
        role="tab"
        aria-controls="nav-home"
        aria-selected="true">Chat
      </a>
      <a
        class="nav-item nav-link"
        id="nav-profile-tab"
        data-toggle="tab"
        href="#media"
        role="tab"
        aria-controls="nav-profile"
        aria-selected="false">Media
      </a>
      <a
        class="nav-item nav-link"
        id="nav-contact-tab"
        data-toggle="tab"
        href="#participants"
        role="tab"
        aria-controls="nav-contact"
        aria-selected="false">Participants
      </a>
    </div>
  </nav>
  <div class="tab-content" id="nav-tabContent">
    <div
      class="tab-pane fade show active"
      id="chat"
      role="tabpanel"
      aria-labelledby="nav-home-tab">
        <app-ecachat></app-ecachat>
    </div>
    <div
      class="tab-pane fade"
      id="media"
      role="tabpanel"
      aria-labelledby="nav-profile-tab">
        <!-- <app-ecamedia></ecaapp-media> -->
    </div>
    <div
      class="tab-pane fade"
      id="participants"
      role="tabpanel"
      aria-labelledby="nav-contact-tab">
        <app-ecaparticipants></app-ecaparticipants>
    </div>
  </div>
  